import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=52f81c9e&"
import script from "./PriceDetail.vue?vue&type=script&lang=js&"
export * from "./PriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports